import { openBlock as i, createElementBlock as s, normalizeClass as u, createElementVNode as d, createTextVNode as a, renderSlot as m, toDisplayString as c, createCommentVNode as b } from "vue";
/* empty css                    */
import v from "./design-system.es128.js";
const f = {
  name: "DsRadio",
  props: {
    /**
     * Selected value for the radio
     */
    modelValue: String,
    /**
     * Actual value for the radio
     */
    val: {
      type: [String, Number],
      required: !0
    },
    /**
     * Required value for validation
     */
    required: Boolean,
    /**
     * Name value for validation
     */
    name: String,
    /**
     * Label for radio, value is a backup if not passed in
     */
    label: String,
    /**
     * True if selection is an error
     */
    error: Boolean,
    /**
     * Disables the radio
     */
    disabled: Boolean
  },
  emits: ["update:modelValue"],
  setup(r, { slots: e }) {
    return {
      slots: e
    };
  },
  computed: {
    selected() {
      return this.modelValue === this.val;
    }
  },
  methods: {
    change() {
      !this.disabled && !this.selected && this.$emit("update:modelValue", this.val);
    }
  }
}, h = { class: "radio-container" }, g = ["value", "checked", "disabled", "required", "name"], V = {
  key: 0,
  class: "label-container"
};
function _(r, e, l, n, S, t) {
  return i(), s("label", {
    class: u(["radio", { selected: t.selected, error: l.error, disabled: l.disabled }])
  }, [
    d("div", h, [
      d("input", {
        type: "radio",
        value: l.val,
        checked: t.selected,
        disabled: l.disabled,
        required: l.required,
        name: l.name,
        class: "visually-hidden",
        onChange: e[0] || (e[0] = (...o) => t.change && t.change(...o))
      }, null, 40, g),
      e[1] || (e[1] = a()),
      e[2] || (e[2] = d("div", { class: "dot" }, null, -1))
    ]),
    e[3] || (e[3] = a()),
    n.slots.default || l.label || l.val ? (i(), s("div", V, [
      m(r.$slots, "default", {}, () => [
        a(c(l.label || l.val), 1)
      ], !0)
    ])) : b("", !0)
  ], 2);
}
const B = /* @__PURE__ */ v(f, [["render", _], ["__scopeId", "data-v-d9c9e506"]]);
export {
  B as default
};
//# sourceMappingURL=design-system.es90.js.map
